import React, { useState } from "react";

import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHHorarioDel } from "services/services-mia/programa-salud/personal/RNHHorarioDel";

/**
 * Baja de un horario. Muestra el que se va a borrar, deshabilitado: no hay nada que
 * completar, solo confirmar sobre cuál se está operando.
 *
 * El botón sale rojo solo: `FormButton` mira el texto —"Eliminar"— y elige la clase.
 */
export default function DeleteModal({ updateList, horario, closeModal }) {
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async () => {
        setInRequest(true);
        const respuesta = await RNHHorarioDel(credentials, {
            id: horario?.id,
            version: horario?.version,
        });
        setInRequest(false);

        if (!respuesta.ok) return;

        setSnackbarInfo({
            message: "Horario eliminado correctamente",
            severity: "success",
            open: true,
        });
        updateList();
        closeModal();
    };

    return (
        <Formik
            initialValues={{
                cod: horario?.cod ?? "",
                nombre: horario?.nombre ?? "",
            }}
            onSubmit={handleSubmit}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Grid
                        container
                        rowSpacing={0}
                        columnSpacing={2}
                        sx={{
                            width: "100%",
                            "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
                        }}
                    >
                        <Grid item xs={4}>
                            <FormikTextInput fullWidth name="cod" labelText="Código" readOnly />
                        </Grid>
                        <Grid item xs={8}>
                            <FormikTextInput fullWidth name="nombre" labelText="Horario" readOnly />
                        </Grid>
                    </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {inRequest && <SpinnerOverlay />}
                </div>
            </Form>
        </Formik>
    );
}
